import { FC } from 'react';

import { CustomHandle } from '../custom-handle';
import { ICustomNode } from '../custom-node';
import './second-contact-action.scss';

// The tier-0 "Second Contact" step is presence-only: placing it in the flow is the whole
// configuration. It captures the applicant's SECOND contact — the channel OPPOSITE the one
// onboarding started with — and verifies it via OTP. Downstream nodes stay locked until this
// node is completed, so it acts as a gate. Nothing to configure here; this body just summarises
// what the step does, consistent with how it renders in the session viewer.
const SECOND_CONTACT_POINTS = [
	{ key: 'send', label: 'Send OTP to the opposite channel' },
	{ key: 'verify', label: 'Verify the OTP to unlock the flow' },
];

export const SecondContactAction: FC<ICustomNode> = ({ id: nodeId }) => {
	return (
		<div className="second-contact-action">
			<CustomHandle value={nodeId} />
			<div className="second-contact-action__summary">
				<div className="second-contact-action__caption">Second contact</div>
				{SECOND_CONTACT_POINTS.map(point => (
					<div className="second-contact-action__field" key={point.key}>
						<span className="second-contact-action__field-label">
							{point.label}
						</span>
						<span className="second-contact-action__field-badge">OTP</span>
					</div>
				))}
				<div className="second-contact-action__note">
					Channel is the opposite of onboarding&apos;s start (email if started
					with phone, else phone). Gates downstream steps until verified.
				</div>
			</div>
		</div>
	);
};
